import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocationData } from "../../components/feature/LocationSelector/types";
import { DEFAULT_LOCATION } from "../../utils/constants";
import { locationStorage } from "../../utils/locationStorage";

interface LocationState {
  location: LocationData | null;
}

const initialState: LocationState = {
  location: locationStorage.getInitialLocation(),
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocation: (state, action: PayloadAction<LocationData>) => {
      state.location = action.payload;
      locationStorage.setLocation(action.payload);
    },
    clearLocation: (state) => {
      const defaultLocation = { ...DEFAULT_LOCATION };
      state.location = defaultLocation;
      locationStorage.setLocation(defaultLocation);
    },
  },
});

export const { setLocation, clearLocation } = locationSlice.actions;
export const locationSelector = (state: { location: LocationState }) =>
  state.location;
export default locationSlice.reducer;
